import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { nanoid } from "nanoid/non-secure";
import * as React from "react";
import { SingleNavigatorContext } from "./EnsureSingleNavigator";
/**
 * Register a navigator in the parent context (either a navigation container or a screen).
 * This is used to prevent multiple navigators under a single container or screen.
 */ export default function useRegisterNavigator() {
    var _React_useState = _sliced_to_array(React.useState(function() {
        return nanoid();
    }), 1), key = _React_useState[0];
    var container = React.useContext(SingleNavigatorContext);
    if (container === undefined) {
        throw new Error("Couldn't register the navigator. Have you wrapped your app with 'NavigationContainer'?\n\nThis can also happen if there are multiple copies of '@react-navigation' packages installed.");
    }
    React.useEffect(function() {
        var register = container.register, unregister = container.unregister;
        register(key);
        return function() {
            return unregister(key);
        };
    }, [
        container,
        key
    ]);
    return key;
}
